import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import styled, { useTheme } from "styled-components";
import withComponentOverride from "../withComponentOverride";
const ZoomContainer = withComponentOverride(styled.div `
	display: flex;
	position: absolute;
	right: 15px;
	top: 15px;
	gap: 2px;
	z-index: 1;
`);
const ZoomButton = withComponentOverride(styled.button `
	display: block;
	appearance: none;
	width: 20px;
	height: 20px;
	border: 0;
	border-radius: 3px;
	cursor: pointer;
	font-size: 20px;
	line-height: 20px;
	padding: 0;
	margin: 0;
	text-align: center;
	vertical-align: middle;

	background: ${(props) => {
    return props.theme.colors.zoomBtnBg;
}};
	color: ${(props) => {
    return props.theme.colors.zoomBtnColor;
}};

	&:hover {
		background: ${(props) => {
    return props.theme.colors.zoomBtnBgHover;
}};
	}
`);
const Zoom = ({ setFontSize, fontSize, minFontSize, maxFontSize, fontSizeStep }) => {
    const { components } = useTheme();
    const handleSizeIncrease = useCallback(() => {
        setFontSize(Math.min(fontSize + fontSizeStep, maxFontSize));
    }, [fontSize, fontSizeStep, maxFontSize, setFontSize]);
    const handleSizeDecrease = useCallback(() => {
        setFontSize(Math.max(fontSize - fontSizeStep, minFontSize));
    }, [fontSize, fontSizeStep, minFontSize, setFontSize]);
    return (_jsxs(ZoomContainer, { componentOverride: components?.ZoomContainer, children: [_jsx(ZoomButton, { type: "button", "data-testid": "support-chat-zoom-plus", onClick: handleSizeIncrease, componentOverride: components?.ZoomButton, children: "+" }), _jsx(ZoomButton, { type: "button", "data-testid": "support-chat-zoom-minus", onClick: handleSizeDecrease, componentOverride: components?.ZoomButton, children: "\u2212" })] }));
};
export default Zoom;
